import { useContext } from 'react';
import { PlanContext } from '../contexts/PlanContext';

export const usePlan = () => {
  const { plan, setPlan } = useContext(PlanContext);

  return [plan, setPlan];
};
export default usePlan;
